/**
 * IntelliGems A/B Test: Labor Day sale tag + announcement
 *
 * Control (A): data-labor-day-sale="false"
 * Variant (B): data-labor-day-sale="true"
 *
 * Dev preview: ?labor_day_sale_test=b
 */
(function () {
  'use strict';

  if (window.__laborDaySaleABTestInit) return;
  window.__laborDaySaleABTestInit = true;

  var BODY_ATTR = 'data-labor-day-sale';
  var ORIGINAL_ATTR = 'data-labor-day-original';
  var applying = false;
  var debounceTimer = null;
  var variantActive = null;
  var syncingAttr = false;

  var SALE_REPLACEMENTS = [
    [/MID\s*SEASON\s*SALE/gi, 'EARLY HOLIDAY SALE'],
    [/SITEWIDE\s*SALE/gi, 'EARLY HOLIDAY SALE'],
    [/CLEARANCE\s*SALE/gi, 'EARLY HOLIDAY SALE']
  ];

  function isDevVariantB() {
    try {
      return new URLSearchParams(window.location.search).get('labor_day_sale_test') === 'b';
    } catch (e) {
      return false;
    }
  }

  function readAttrTrue(el) {
    if (!el) return false;
    var value = el.getAttribute(BODY_ATTR);
    return value === 'true' || value === '1';
  }

  function isVariantB() {
    if (isDevVariantB()) return true;
    return readAttrTrue(document.body) || readAttrTrue(document.documentElement);
  }

  function getAnnouncementTarget() {
    var content = document.querySelector('.AnnouncementBar__Content');
    if (!content) return null;
    return content.querySelector('a') || content;
  }

  function applyAnnouncement(enable) {
    var target = getAnnouncementTarget();
    if (!target) return;

    if (!target.getAttribute(ORIGINAL_ATTR)) {
      target.setAttribute(ORIGINAL_ATTR, target.innerHTML);
    }

    var original = target.getAttribute(ORIGINAL_ATTR);
    if (!original) return;

    if (enable) {
      var next = original;
      for (var i = 0; i < SALE_REPLACEMENTS.length; i++) {
        next = next.replace(SALE_REPLACEMENTS[i][0], SALE_REPLACEMENTS[i][1]);
      }
      if (target.innerHTML !== next) {
        target.innerHTML = next;
      }
    } else if (target.innerHTML !== original) {
      target.innerHTML = original;
    }
  }

  function ensureTag() {
    var row = document.querySelector('.Product__GalleryTags');
    var media = document.querySelector('.Product__SlideshowMedia');
    var host = row || media;
    if (!host) return;

    if (!document.querySelector('.labor-day-sale-tag-ab')) {
      var tag = document.createElement('span');
      tag.className = 'labor-day-sale-tag-ab labor-day-sale-tag-ab--gallery';
      tag.textContent = 'EARLY HOLIDAY SALE';

      var bestSeller = host.querySelector('.best-seller-tag-ab');
      if (bestSeller && bestSeller.nextSibling) {
        host.insertBefore(tag, bestSeller.nextSibling);
      } else if (bestSeller) {
        host.appendChild(tag);
      } else {
        host.insertBefore(tag, host.firstChild);
      }
    }
  }

  function syncAttr(variantB) {
    var value = variantB ? 'true' : 'false';
    syncingAttr = true;
    try {
      if (document.body && document.body.getAttribute(BODY_ATTR) !== value) {
        document.body.setAttribute(BODY_ATTR, value);
      }
      if (document.documentElement.getAttribute(BODY_ATTR) !== value) {
        document.documentElement.setAttribute(BODY_ATTR, value);
      }
    } finally {
      syncingAttr = false;
    }
  }

  function applyVariant() {
    if (applying) return;
    applying = true;

    try {
      var variantB = isVariantB();
      if (variantB === variantActive) return;

      variantActive = variantB;
      document.documentElement.classList.toggle('labor-day-sale-b', variantB);
      syncAttr(variantB);

      if (variantB) ensureTag();
      applyAnnouncement(variantB);
    } finally {
      applying = false;
    }
  }

  function scheduleApply() {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(applyVariant, 40);
  }

  function init() {
    if (isDevVariantB()) {
      syncAttr(true);
    }

    applyVariant();

    if (!document.body) return;

    new MutationObserver(function (mutations) {
      if (syncingAttr || applying) return;

      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].attributeName === BODY_ATTR ||
          mutations[i].attributeName === 'data-gem-variant' ||
          mutations[i].attributeName === 'data-gem-test-active') {
          scheduleApply();
          return;
        }
      }
    }).observe(document.body, {
      attributes: true,
      attributeFilter: [BODY_ATTR, 'data-gem-variant', 'data-gem-test-active']
    });

    document.addEventListener('gem:variant:changed', scheduleApply);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
